<script setup>
import Buttons from '@/components/ui/Buttons.vue';
defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
});
</script>
<template>
  <section
    :id="data.id"
    class="section"
    :class="[
      data?.background_color ? `bg-${data?.background_color}` : '',
      data?.spacing?.top
        ? `section--top-${data.spacing.top}`
        : 'section--top-xl',
      data?.spacing?.bottom
        ? `section--bottom-${data.spacing.bottom}`
        : 'section--bottom-xl',
    ]"
    data-aos="fade-up"
    data-aos-easing="ease-out-cubic"
  >
    <div class="container">
      <div
        class="corporate-terms"
        :class="[data?.background_color === 'black' ? 'white' : '']"
      >
        <h2
          v-if="data?.title"
          class="mb-0 corporate-terms__title h2"
          data-aos="fade-up"
          data-aos-easing="ease-out-cubic"
          v-html="data?.title"
        ></h2>
        <div class="corporate-terms__content">
          <NuxtImg
            v-if="data?.image && data?.image?.src && data?.image?.alt"
            :src="data.image.src"
            :alt="data.image.alt"
            :height="data.image.height"
            :width="data.image.width"
            class="corporate-terms__image"
            data-aos="zoom-in"
            data-aos-easing="ease-out-quad"
            loading="lazy"
          />
          <div class="corporate-terms__bottom">
            <p
              v-if="data?.subtitle"
              class="mb-0 corporate-terms__subtitle accent"
              data-aos="fade-up"
              data-aos-easing="ease-out-cubic"
              v-html="data?.subtitle"
            ></p>
            <Buttons
              v-if="data.buttons && data?.buttons.length > 0"
              class="corporate-terms__buttons"
              :buttons="data.buttons"
              :background-color="data?.background_color"
              data-aos="fade-up"
              data-aos-easing="ease-out-cubic"
              :buttons-prefix-class="'js-button-corporate-terms'"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
@use 'sass:math';
.corporate-terms {
  display: grid;
  grid-template-columns: 1fr;
  gap: 56px;
  text-align: center;
  @include media-breakpoint-up(sm) {
    gap: 80px;
  }
  @include media-breakpoint-up(md) {
    gap: 72px;
    grid-template-columns: 3.55fr 8.45fr;
    text-align: left;
  }
  @include media-breakpoint-up(xl) {
    @include responsive-spacing(gap, 72);
  }
  &__title {
    margin: 0;
  }
  &__content {
    display: grid;
    grid-template-columns: 1fr;
    gap: 32px;
    @include media-breakpoint-up(sm) {
      gap: 56px;
    }
    @include media-breakpoint-up(md) {
      grid-template-columns: 6.45fr 5.55fr;
      gap: 72px;
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(gap, 72);
    }
  }
  &__image {
    border-radius: 8px;
    margin: 0 auto;
    height: auto;
    width: 80.5%;
    @include media-breakpoint-up(sm) {
      width: 53.3%;
    }
    @include media-breakpoint-up(md) {
      width: 100%;
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(border-radius, 8);
    }
  }
  &__bottom {
    display: flex;
    flex-direction: column;
    gap: 32px;
    @include media-breakpoint-up(sm) {
      gap: 56px;
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(gap, 56);
    }
  }
  &__subtitle {
    margin: 0;
    @include media-breakpoint-up(sm) {
      margin: 0 auto;
      width: 80%;
    }
    @include media-breakpoint-up(md) {
      width: 100%;
    }
  }
  &__buttons {
    justify-content: center;
    @include media-breakpoint-up(md) {
      align-items: flex-start;
      justify-content: flex-start;
      margin: 0;
    }
  }
}
</style>
